declare global {
    interface Window {
        nextRecaptchaInit?: (() => void) | null;
        grecaptcha?: ReCaptchaV2.ReCaptcha | null;
    }
}

export class GCaptchaHelper {
    private initialisers: Array<(recaptcha: ReCaptchaV2.ReCaptcha) => void> = [];
    private recaptcha: ReCaptchaV2.ReCaptcha | null = null;

    constructor(private readonly siteKey: string) {}

    onRecaptchaInit(this: this, callback: (recaptcha: ReCaptchaV2.ReCaptcha) => void) {
        this.loadRecaptchaIfNeed();

        const recaptcha = this.recaptcha;
        if (recaptcha != null) {
            setTimeout(function () {
                callback(recaptcha);
            }, 0);
        } else {
            this.initialisers.push(callback);
        }
    }

    loadRecaptcha(this: this): Promise<ReCaptchaV2.ReCaptcha> {
        return new Promise((resolve, _reject) => {
            this.onRecaptchaInit((recaptcha) => {
                resolve(recaptcha);
            });
        });
    }

    async loadAndReadyRecaptcha(this: this): Promise<ReCaptchaV2.ReCaptcha> {
        const recaptcha = await this.loadRecaptcha();
        return new Promise((resolve, _reject) => {
            recaptcha.ready(() => {
                resolve(recaptcha);
            });
        });
    }

    async executeRecaptcha(this: this, action: string): Promise<string> {
        const recaptcha = await this.loadAndReadyRecaptcha();
        return new Promise<string>((resolve, reject) => {
            recaptcha.execute(this.siteKey, { action }).then(resolve, reject);
        });
    }

    private loadRecaptchaIfNeed(this: this) {
        if (typeof window !== 'undefined') {
            window.nextRecaptchaInit = () => {
                const recaptcha = window['grecaptcha'] as ReCaptchaV2.ReCaptcha;
                this.recaptcha = recaptcha;
                this.initialisers.forEach((callback) => {
                    callback(recaptcha);
                });
                this.initialisers = [];
            };

            const head = document.getElementsByTagName('head')[0];

            const scriptId = 'next-load-recaptcha-script';
            if (document.getElementById(scriptId)) {
                return;
            }

            const js = document.createElement('script');
            js.id = scriptId;
            js.src = `https://www.google.com/recaptcha/api.js?onload=nextRecaptchaInit&render=${this.siteKey}`;

            head?.append(js);
        }
    }
}
